import { PlusBoxIcon } from './PlusBoxIcon';

/**
 * author: Google
 * id 87EE041D-81D2-4F1A-A757-F76E9D8686EF
 * name plus-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-box.svg
 * tags
 * - Math 
 */
export const AddBoxIcon = PlusBoxIcon;
export default AddBoxIcon